module.exports = "/_next/static/images/logo-mobile-b2b-new-f54876d4ffe8f116f1b936ee17a99655.svg";